export class FsrDvHsw {
    constructor(socket, log) {
        this.socket = socket;
        this.autoSwitch = false;
        this.firmwareVersion = '1.0.1';
        this.videoSelection = '1';
        this.asyncHandlers = [
            {
                name: 'setAutoSwitch',
                regExp: />>(AUTO|MANUAL)\s+Switch/i,
                callback: (match) => {
                    this.autoSwitch = match[1].toUpperCase() === 'AUTO';
                    this.socket.send(`<<${this.autoSwitch ? 'AUTO' : 'MANUAL'} Switch`);
                },
            },
            {
                name: 'getStatus',
                regExp: />>SysInfo/i,
                callback: (match) => {
                    const statusResp = [];
                    statusResp.push(`<<${this.autoSwitch ? 'AUTO' : 'MANUAL'} Switch`);
                    statusResp.push(`<<HDMI${this.videoSelection}`);
                    statusResp.push(`<< WUHARC-H2`);
                    statusResp.push(`<< VER ${this.firmwareVersion}`);
                    statusResp.push(`<<AUDInternal`);
                    statusResp.push(`<<EDID0`);
                    statusResp.push(`<<HDCP: Active`);
                    statusResp.push(`<< --------`);
                    statusResp.forEach(stat => {
                        this.socket.send(`${stat}`);
                    });
                },
            },
            {
                name: 'setVideo',
                regExp: />>HDMI(\d+)/i,
                callback: (match) => {
                    if (this.autoSwitch) {
                        this.socket.send(`<<AUTO Switch`);
                    }
                    else {
                        this.videoSelection = match[1];
                        this.socket.send(`<<HDMI${this.videoSelection}`);
                    }
                },
            },
        ];
    }
}
FsrDvHsw.emulatorType = 'socketEmulator';
FsrDvHsw.key = '-NXLDUi88xVZaQE6j2E6';
